module.exports = __webpack_public_path__ + "static/ottaviani-d3246eb694756cd609852994eefde3da.jpg";